import { useEffect, useRef } from 'react';

import feedback from 'assets/img/experienceCatalog/feedback.png';
import Button from 'components/ui/button';
import { FOCO_VISIVEL } from 'utils/foco';

const CAIXA = 'mb-6 flex flex-col items-start rounded-xl bg-brand-white px-6 py-7 shadow-jj-01 sm:px-8';
const TITULO = `m-0 mb-3 font-display text-[24px] font-extrabold leading-[1.2] text-brand-blue-dark ${FOCO_VISIVEL}`;

/** Confirmação do cancelamento: até quando dá para escolher outra, e a volta por ação do jogador (DESF-01.2). */
export function CancelamentoRealizado({ prazo, onVerCatalogo }: { prazo: string; onVerCatalogo: () => void }) {
  // O botão que abriu o diálogo sai da tela junto com a experiência: o foco vem para a confirmação.
  const tituloRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    tituloRef.current?.focus();
  }, []);

  return (
    <section aria-labelledby="titulo-cancelamento-realizado" className={CAIXA}>
      <div aria-hidden="true" className="mb-[18px] flex h-14 w-14 items-center justify-center rounded-full bg-brand-yellow text-brand-blue">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" focusable="false">
          <path d="M20 6 9 17l-5-5" />
        </svg>
      </div>
      <h2 ref={tituloRef} id="titulo-cancelamento-realizado" tabIndex={0} className={TITULO}>
        Cancelamento realizado!
      </h2>
      <p className="m-0 mb-6 text-[15px] leading-[1.6] text-content">
        Você cancelou o resgate da sua experiência e poderá escolher outra experiência até <strong>{prazo}</strong>.
      </p>
      <Button variant="solido" onClick={onVerCatalogo}>
        Ver Catálogo de Experiência
      </Button>
    </section>
  );
}

/** Sem resgate e com o prazo do ciclo encerrado (CAT-34), com a volta para a vitrine em consulta (TRC-24). */
export function PrazoEncerrado({ semestre, onVerCatalogo }: { semestre: string; onVerCatalogo: () => void }) {
  return (
    <section aria-labelledby="titulo-prazo-encerrado" className={`${CAIXA} sm:flex-row sm:items-center sm:gap-8`}>
      <div className="min-w-0 flex-1">
        <h2 id="titulo-prazo-encerrado" tabIndex={0} className={TITULO}>
          Prazo encerrado
        </h2>
        <p className="m-0 text-[15px] leading-[1.6] text-content">No {semestre}, não havia experiências elegíveis para resgate em seu perfil.</p>
        <div className="mt-5">
          <Button variant="secundario" onClick={onVerCatalogo}>
            Ver experiências do ciclo
          </Button>
        </div>
      </div>
      <img src={feedback} alt="" aria-hidden="true" className="mt-6 block w-full max-w-[260px] self-center sm:mt-0" />
    </section>
  );
}
